import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let option = useDataValue({
    context: 'option',
    path: 'id',
    viewPath: props.viewPath,
  })
  let selected = useDataValue({
    context: 'settings',
    path: 'patient_default',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'settings',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (option === selected) return

    return submit({
      key: 'patient_default',
      value: option,
    })
  }
}
